import * as React from 'react';
import { PortalTopPart } from 'components/PortalStructure/Layouts/Portal/PortalTopPart';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { Link, RouteComponentProps } from 'react-router';
import { getShopCard, resetData } from 'redux/modules/shop/shopcard';
import { closeModal, showModal } from 'redux/modules/modal';
import { ITranslateProps } from 'models/common';
import { Dispatch } from 'react-redux';

interface IParams {
	id: string;
	officeId?: string;
}

interface IProps
	extends RouteComponentProps<IParams, {}>,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps>,
		ITranslateProps {}

const mapStateToProps = (state: IStore) => ({
	shopCard: state.shopcard.shopcard,
	customers: state.shopcard.customers,
});

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
	resetData: () => dispatch(resetData()),
	getShopCardById: (id: string) => dispatch(getShopCard(id, false, true)),
	showModal: (type: string, modalProps: any) => dispatch(showModal(type, modalProps)),
	closeModal: () => dispatch(closeModal()),
});

@connect(mapStateToProps, mapDispatchToProps)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopInfo extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
		this.changeTabAction = this.changeTabAction.bind(this);
	}

	componentDidMount() {
		const { params } = this.props;
		this.props.getShopCardById(params.id);
	}

	componentDidUpdate(prevProps: Readonly<IProps>) {
		const { params } = this.props;
		if (params.id !== prevProps.params.id) {
			this.props.getShopCardById(params.id);
		}
	}

	componentWillUnmount() {
		this.props.resetData();
	}

	private changeTabAction(selectedTab: string) {
		this.setState({ selectedTab });
	}

	render() {
		if (typeof window === 'undefined') {
			return null;
		}
		const { shopCard, t } = this.props;
		const shopId = this.props.params.id;

		return (
			<>
				<div className="profile shop shopInfo">
					<PortalTopPart item={{ ...shopCard, code: undefined }} type="shop" />
					<div className="content">
						<div className="tabs sub">
							<Link to={`/shop/${shopId}/edit/customers`} className="tab-link" activeClassName="tab-link-active">
								<p>{t('User_ShopCard_Customers')}</p>
							</Link>
							<Link to={`/shop/${shopId}/edit/analytics`} className="tab-link" activeClassName="tab-link-active">
								<p>{t('User_ShopCard_Analytics')}</p>
							</Link>
						</div>
						{this.props.children}
					</div>
				</div>
			</>
		);
	}
}

export default ShopInfo;
